import { isNil } from 'lodash';
import ordinal from 'ordinal';

import { GRADUATED_GRADE, STUDENT_SCOPE } from 'constants/gradeYears';
import { EL } from 'routes/constants';

export const getGradeName = ({
  grade,
  isLongVariant = false,
  useShortKindergarten = false,
  noOrdinal = false,
  t,
}) => {
  if (grade === 0) {
    if (t) {
      return useShortKindergarten
        ? 'K'
        : t('ElementaryCheckins.Utils.Kindergarten');
    }
    return useShortKindergarten ? 'K' : 'Kindergarten';
  }
  if (grade === GRADUATED_GRADE) {
    return t ? t('ElementaryCheckins.Utils.Alumni') : 'Alumni';
  }
  if (isNil(grade)) {
    return t ? t('ElementaryCheckins.Utils.NA') : 'N/A';
  }
  if (noOrdinal) {
    return grade;
  }
  if (t) {
    return isLongVariant
      ? t('ElementaryCheckins.Utils.Grade', { count: grade })
      : t('ElementaryCheckins.Utils.GradeShort', { count: grade });
  }
  return `${ordinal(grade)}${isLongVariant ? ' Grade' : ''}`;
};

export const getUrlPrefix = studentScope =>
  studentScope === STUDENT_SCOPE.ELEMENTARY ? EL : '';
